import { registerFlow } from '../../../core/flow-register';
import { makeFlow } from '../index';
import { IRAAccountTypes } from '../loaders';

registerFlow(
  makeFlow('traditional-ira', {
    toIRAAccountType: IRAAccountTypes.TRADITIONAL,
    fromIRAAccountType: IRAAccountTypes.TRADITIONAL
  })
);
